import loadable from '@loadable/component';
import Loading from '../components/Loader';

const OnDemandTradie = loadable(
  () => import(/* webpackChunkName: "ondemandtradie" */ '../containers/OnDemandTradie'),
  { fallback: Loading }
);

export default OnDemandTradie;
